import React, { useContext } from 'react';
import Table from './Table';
import Pagination from './Pagination';
import { TableContext } from '../../contexts/TableContext';

const Layout: React.FC = () => {
  const { headerSection, footerSection } = useContext(TableContext);

  return (
    <div className="card obs-table-card" style={{ overflow: 'hidden' }}>
      {headerSection && <div className="card-body pb-0">{headerSection}</div>}
      <div className="table-responsive">
        <Table />
      </div>
      <Pagination />
      {footerSection && footerSection}
    </div>
  );
};

export default Layout;
